import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL, USER_URL } from "../../constant/api";
import axios from "axios";
import ProductImagesGrid from "../../components/ProductImagesGrid/ProductImagesGrid";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import ReviewCard from "../../components/ReviewCard/ReviewCard";
import ProductApprovalModel from "../../components/AdminModal/ProductApprovalModel";
import Loader from "../../components/Loader/Loader";

function AdminProductView() {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [category, setCategory] = useState(null);
  const [reviews, setReviews] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productStatus, setProductStatus] = useState("");

  const openModal = useCallback((productData, status) => {
    setSelectedProduct(productData);
    setProductStatus(status);
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedProduct(null);
    setProductStatus("");
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await USER_URL.get(`/products/${productId}/`);
        setProduct(response.data.Data);
        console.log("APi response:", response.data);
      } catch (error) {
        console.error("Error fetching product:", error);
        setError("Failed to fetch product details.");
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  useEffect(() => {
    if (!product?.length || !product[0]?.category) return; // Ensure product exists before fetching

    console.log(product[0].category);
    axios
      .get(`${BASE_URL}/categories/${product[0].category}/`)
      .then((res) => {
        const data = res.data?.Data;
        if (Array.isArray(data) && data.length > 0) {
          setCategory(data[0]); // Set the first object instead of the whole array
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [product]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/products/reviews/${productId}/`,
        );
        // console.log("APi response3:", response.data);
        setReviews(response.data.Data || []);
      } catch (err) {
        console.error("Error fetching reviews", err);
        setError(err.message);
      }
    };

    fetchReviews();
  }, [productId]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <p>{error}</p>;
  }

  const product_rating = product?.[0]?.product_rating;
  const totalStars = 5;

  const renderStars = (rating) => {
    const filledStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0);

    return (
      <>
        {[...Array(filledStars)].map((_, index) => (
          <FaStar key={`filled-${index}`} className="h-5 w-5 text-yellow-500" />
        ))}
        {hasHalfStar && <FaStarHalfAlt className="h-5 w-5 text-yellow-500" />}
        {[...Array(emptyStars)].map((_, index) => (
          <FaRegStar key={`empty-${index}`} className="h-5 w-5 text-gray-400" />
        ))}
      </>
    );
  };

  return (
    <div className="flex  flex-col gap-2 md:flex-row">
      {/* Left Column */}
      <div className="flex w-full flex-col gap-2 lg:w-1/2">
        <ProductImagesGrid productImages={product?.[0]?.product_images} />
        <div className="hidden md:block">
          <div>
            <h2 className="text-2xl font-medium md:text-2xl">{product?.[0]?.name}</h2>
            <p className="pt-2 font-medium">Product Description</p>
            <p className="mt-2 text-gray-500">
              {product?.[0]?.description || "No description available."}
            </p>
          </div>
          <div>
            <div className="mt-1 flex items-center space-x-1 sm:mt-2">
              {renderStars(product_rating)}
              <p className="ml-2 text-sm text-gray-500">
                {product?.[0]?.product_rating} (
                {product?.[0]?.product_review_count} Reviews)
              </p>
            </div>
            <div>
              <div className="h-52 overflow-y-auto">
                {reviews.map((review, index) => (
                  <ReviewCard
                    key={index}
                    review={review}
                    renderStars={renderStars}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column */}
      <div className="flex flex-col gap-1 md:gap-3 lg:w-1/2">
        <p className="text-lg font-medium">Seller Name : {product?.[0]?.seller_name || "No seller name available."}</p>
        <p className="text-lg font-medium">Brand Name : {product?.[0]?.brand_name || "No brand name available."}</p>

        <div className="block md:hidden">
          <p className="text-xl font-medium">Product Description</p>
          <p className="mt-2 text-gray-500">
            {product?.[0]?.description || "No description available."}
          </p>
        </div>

        <div className="mt-1 flex items-center space-x-1 sm:mt-2">
          {renderStars(product_rating)}
          <p className="ml-2 text-sm text-gray-500">
            {product?.[0]?.product_rating} ({product?.[0]?.product_review_count}{" "}
            Reviews)
          </p>
        </div>
        <p className="mt-2 text-sm text-gray-500 md:text-base">
          Transportation fee:{" "}
          <strong>{product?.[0]?.currency_symbol || "₹"} {product?.[0]?.delivery_charge || "0.00"} </strong>
        </p>
        <p className="mt-2 text-sm text-gray-500 md:text-base">
          Status: <strong> {product?.[0]?.stock_status ? "In stock" : "Out of stock"}</strong>
        </p>
        <div className="flex gap-2">
          <button
            className="w-full rounded-lg bg-brand-primary px-4 py-1 text-white md:w-32"
            onClick={() => openModal(product?.[0], "Approved")}
          >
            Approve
          </button>
          <button
            className="w-full rounded-lg border-2 px-4 py-1 text-black md:w-32"
            onClick={() => openModal(product?.[0], "Rejected")}
          >
            Reject
          </button>
        </div>
        <p className="mt-2 text-sm text-gray-500 md:text-base">
          Stock:{" "}
          <strong>
            {product?.[0]?.stock}
          </strong>
        </p>

        <label className="block">
          <span className="text-sm text-gray-500 md:text-base">
            Minimum quantity
          </span>
          <div className="mt-2 flex flex-row justify-between gap-2 md:justify-start">
            {[
              product?.[0]?.min_order_quantity,
              product?.[0]?.min_order_quantity_two,
              product?.[0]?.min_order_quantity_three,
              product?.[0]?.min_order_quantity_four,
              product?.[0]?.min_order_quantity_five,
            ].map((qty) => (
              <div
                key={qty}
                className="cursor-pointer rounded-lg border p-4 text-center hover:border-brand-primary hover:text-brand-primary md:p-2"
              >
                {qty}
              </div>
            ))}
          </div>
        </label>

        <div className="w-full md:w-1/2">
          <p className="text-sm text-gray-500 md:text-base">Category</p>
          <div className="my-1 cursor-pointer rounded-lg border p-2 text-center hover:border-brand-primary hover:text-brand-primary">
            {category?.name ? category.name : "No category available."}
          </div>
          <p className="text-sm text-gray-500 md:text-base">Subcategory</p>
          {/* <p>{product?.[0]?.subcategory}</p> */}
          {category?.subcategories
            ?.filter((sub) => sub.id === product?.[0]?.subcategory)
            .map((sub) => (
              <div
                key={sub.id}
                className="my-1 cursor-pointer rounded-lg border p-2 text-center hover:border-brand-primary hover:text-brand-primary"
              >
                {sub.name ? sub.name : "No subcategory available."}
              </div>
            ))}
        </div>
      </div>

      <div className="block md:hidden">
        <div>
          <div className="mt-1 flex items-center space-x-1 sm:mt-2">
            {renderStars(product_rating)}
            <p className="ml-2 text-sm text-gray-500">
              {product?.[0]?.product_rating} (
              {product?.[0]?.product_review_count} Reviews)
            </p>
          </div>
          <div>
            <div className="h-52 overflow-y-auto">
              {reviews.map((review, index) => (
                <ReviewCard
                  key={index}
                  review={review}
                  renderStars={renderStars}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <ProductApprovalModel
        selectedProduct={selectedProduct}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        status={productStatus}
      />
    </div>
  );
}

export default AdminProductView;
